export class ProductIdentity
{
    public id: number;
    public model: number;
}